import { lazy } from 'react'

const LoginScreen = lazy(() => import('../screen/Login'))
const ForgotScreen = lazy(() => import('../screen/ForgotPassword'))
const FirstAccess = lazy(() => import('../screen/FirstAccess'))
const SelectMethod = lazy(() => import('../screen/SelectMethod'))
const SignOnContainer   = lazy(() => import("../screen/SignOnContainer"))
const MFAScreen = lazy(() => import('../screen/MFA'))
const MFAChooseMethodScreen = lazy(() => import('../screen/MFAChooseMethod'))
const MFAMultipleQuestionsScreen = lazy(() => import('../screen/MFAMultipleQuestions'))

const dashboard = [
  {
    path: '/login',
    component: LoginScreen,
    exact: true
  },{
    path: '/forgot',
    component: ForgotScreen,
    exact: true
  },{
    path: '/first-access',
    component: FirstAccess,
    exact: true
  },{
    path: '/first-access/select-method',
    component: SelectMethod,
    exact: true
  },{
    path: "/sso",
    component: SignOnContainer,
    exact: false
  },{
    path: '/mfa/choose',
    component: MFAChooseMethodScreen,
    exact: true
  },{
    path: '/mfa',
    component: MFAScreen,
    exact: true
  },{
    path: '/mfa-multiple-questions',
    component: MFAMultipleQuestionsScreen,
    exact: true
  },
]

export default dashboard
